<template>
  <div class="annotate-label-placement">
    <v-alert
      type="info"
      variant="tonal"
      density="compact"
      class="annotate-label-placement__help text-caption mb-3"
    >
      {{ $t('annotate.placement_help') }}
    </v-alert>

    <annotate-labels
      :disabled="disabled"
      placement-mode
      type="box"
      :selected-label-name="selectedNameForType('box')"
      @label_selected="onLabelSelected"
    ></annotate-labels>
    <annotate-labels
      :disabled="disabled"
      placement-mode
      type="point"
      :selected-label-name="selectedNameForType('point')"
      @label_selected="onLabelSelected"
    ></annotate-labels>

    <div v-if="pendingPlacement" class="annotate-label-placement__active mt-2">
      <v-chip size="small" color="primary" variant="tonal" class="mr-2">
        {{ $t('annotate.placement_selected', { label: pendingPlacement.name, type: pendingPlacement.type }) }}
      </v-chip>
      <v-btn size="x-small" variant="text" @click="$emit('clear')">
        {{ $t('annotate.placement_clear') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import AnnotateLabels from '@/components/AnnotateLabels.vue';

export default {
  name: 'AnnotateLabelPlacement',
  components: { AnnotateLabels },
  props: {
    disabled: { type: Boolean, default: false },
    pendingPlacement: { type: Object, default: null },
  },
  methods: {
    selectedNameForType(type) {
      if (!this.pendingPlacement || this.pendingPlacement.type !== type) {
        return null;
      }
      return this.pendingPlacement.name;
    },
    onLabelSelected(payload) {
      this.$emit('label_selected', payload);
    },
  },
};
</script>

<style scoped>
.annotate-label-placement__help {
  line-height: 1.45;
}

.annotate-label-placement__active {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
</style>
